import { render, staticRenderFns } from "./AddLocalesToVideoModal.vue?vue&type=template&id=4b3d0f70&scoped=true&"
import script from "./AddLocalesToVideoModal.vue?vue&type=script&lang=js&"
export * from "./AddLocalesToVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./AddLocalesToVideoModal.vue?vue&type=style&index=0&id=4b3d0f70&prod&lang=scss&"
import style1 from "./AddLocalesToVideoModal.vue?vue&type=style&index=1&id=4b3d0f70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3d0f70",
  null
  
)

export default component.exports